import { EnvironmentService } from '../environment/environment.service';
import { Environment } from '../environment/environment';
import { Injectable, inject } from '@angular/core';
import { SystemTypeCode, ObjectTypeCode } from './system-type-constants';

/**************************************
 *
 *  This naming convention is temporary
 *  until we can fully refactor apiurls
 *  into Internal and External
 *
 **************************************/

@Injectable({
  providedIn: 'root',
})
export class ApiUrls {

  
 

  constructor() {
    const environmentService = inject(EnvironmentService);

    const config = environmentService.getEnvironment();

    this.address._initialize(config);
    this.claim._initialize(config);
    this.forms._initialize(config);
    this.formTemplate._initialize(config);
    this.notification._initialize(config);
    this.claim._initialize(config);
    this.objectStatus._initialize(config);
    this.reference._initialize(config);
    this.priorAuthorization._initialize(config);
    this.priorAuthorizationRequest._initialize(config);
    this.postalCodePrepopulate._initialize(config);
  }

  reference = {
    get(refDataType: string) {
      return `${this.refDataUrl}/api/reference/${refDataType}`;
    },
    getById(refDataType: string, id: number) {
      return `${this.refDataUrl}/api/reference/${refDataType}/${id}`;
    },
    getSystemRoles() {
      return `${this.refDataUrl}/api/reference/systemRoles`;
    },
    getUsStates() {
      return `${this.refDataUrl}/api/reference/usStates`;
    },
    getPhysicianNameByNpi(id: string) {
      return `${this.refDataUrl}/api/reference/physicianNameByNpi/${id}`;
    },
    getPhysicianNameByFromNpiRegistry(id: string) {
      return `https://npiregistry.cms.hhs.gov/api?version=2.1&number=${id}`;
    },
    _initialize(config: Environment) {
      this.refDataUrl = config.baseUrls.refApiUrl;
    },
  };

  formTemplate = {
    getEntityObjectTypes(): string {
      return `${this.formTemplateApiUrlBase}/entityObjectTypes`;
    },
    getFormTemplates(): string {
      return `${this.formTemplateApiUrlBase}/list`;
    },
    getFormTemplate(id: number): string {
      return `${this.formTemplateApiUrlBase}/${id}`;
    },
    create(): string {
      return `${this.formTemplateApiUrlBase}`;
    },
    update(id: number): string {
      return `${this.formTemplateApiUrlBase}/${id}`;
    },
    deactivate(id: number): string {
      return `${this.formTemplateApiUrlBase}/${id}/deactivate`;
    },
    getUploadSasInfo(): string {
      return `${this.formTemplateApiUrlBase}/uploadSasUri`;
    },
    getDownloadSasInfo(id: number): string {
      return `${this.formTemplateApiUrlBase}/downloadSasUri/${id}`;
    },
    getNewVersion(): string {
      return `${this.formTemplateApiUrlBase}/newVersion`;
    },
    _initialize(config: Environment) {
      this.formTemplateApiUrlBase = config.baseUrls.documentApiUrl + '/api/formTemplate';
    },
  };

  address = {
    getLocations(postalCode: string) {
      return `${this.locationUrl}/${postalCode}`;
    },
    _initialize(config: Environment) {
      //this.addressUrl = config.baseUrls.entityApiUrl + '/api/address';
      this.locationUrl = config.baseUrls.refApiUrl + '/api/geographiclocation';
    },
  };

  forms = {
    employerForm() {
      return this.entityApiUrl + '/api/metadata/employer/';
    },
    employerSearchForm() {
      return this.entityApiUrl + '/api/metadata/employersearch/';
    },
    employerLookup() {
      return this.entityApiUrl + '/api/metadata/employersearch/';
    },
    insurerForm() {
      return this.entityApiUrl + '/api/metadata/insurer/';
    },
    medicalsupplierSearchForm() {
      return this.entityApiUrl + '/api/metadata/medicalsuppliersearch/';
    },
    userRegistrationForm() {
      return this.userApiUrl + '/api/metadata/userregistration/';
    },
    userProfileForm() {
      return this.userApiUrl + '/api/metadata/externalUserProfile/';
    },
    queueDetailsForm() {
      return this.userApiUrl + '/api/metadata/queuedetails/';
    },
    systemExternalUserLookupForm() {
      return this.userApiUrl + '/api/metadata/externalsystemuserlookup/';
    },
    systemUserLookupForm() {
      return this.userApiUrl + '/api/metadata/systemuserlookup/';
    },
    loginForm() {
      return this.userApiUrl + '/api/metadata/login/';
    },
    healthcareProviderForm() {
      return this.entityApiUrl + '/api/metadata/healthcareProvider/';
    },
    specialtyForm() {
      return this.entityApiUrl + '/api/metadata/healthcareProviderlicensespecialty/';
    },
    designationForm() {
      return this.entityApiUrl + '/api/metadata/impartialspecialistdesignations';
    },
    insurerSearchForm() {
      return this.entityApiUrl + '/api/metadata/insurersearch/';
    },
    medicalSupplierForm() {
      return this.entityApiUrl + '/api/metadata/medicalsupplier/';
    },
    medicalSupplierLookup() {
      return this.entityApiUrl + '/api/metadata/medicalsupplierlookup/';
    },
    insurerLookup() {
      return this.entityApiUrl + '/api/metadata/insurerlookup/';
    },
    insurerExternalLookup() {
      return this.entityApiUrl + '/api/external/metadata/insurerlookup/';
    },
    healthcareProviderLicenseForm() {
      return this.entityApiUrl + '/api/metadata/healthcareProviderlicense/';
    },
    claimantForm() {
      return this.entityApiUrl + '/api/metadata/claimant';
    },
    claimantLookup() {
      return this.entityApiUrl + '/api/metadata/claimantsearch/';
    },
    claimantSearchForm() {
      return this.entityApiUrl + '/api/metadata/claimantsearch/';
    },
    thirdPartyAdministratorForm() {
      return this.entityApiUrl + '/api/metadata/thirdpartyadministrator';
    },
    thirdPartyAdministratorSearchForm() {
      return this.entityApiUrl + '/api/metadata/thirdpartyadministratorsearch';
    },
    thirdPartyAdministratorLookup() {
      return this.entityApiUrl + '/api/metadata/thirdpartyadministratorlookup';
    },
    thirdPartyAdministratorExternalLookup() {
      return this.entityApiUrl + '/api/external/metadata/thirdpartyadministratorlookup';
    },
    healthcareProviderSearchForm() {
      return this.entityApiUrl + '/api/metadata/healthcareProvidersearch/';
    },
    healthcareProviderLookup() {
      return this.entityApiUrl + '/api/metadata/healthcareProviderlookup/';
    },
    healthcareProviderLookupSupervisoryRelationship() {
      return this.entityApiUrl + '/api/metadata/healthcareProviderLookupSupervisoryRelationship/';
    },
    healthcareProviderMedicalSupplierRelationshipForm() {
      return this.entityApiUrl + '/api/metadata/hcp-medical-supplier-relationship/';
    },
    healthcareProviderSupervisorRelationshipForm() {
      return this.entityApiUrl + '/api/metadata/hcp-supervisor-relationship/';
    },
    addressForm() {
      return this.entityApiUrl + '/api/metadata/address/';
    },
    primaryAddressForm() {
      return this.entityApiUrl + '/api/metadata/primaryaddress/';
    },
    workRequestForm() {
      return this.workflowApiUrl + '/api/metadata/workrequest';
    },
    bulkWorkRequestForm() {
      return this.workflowApiUrl + '/api/metadata/bulkupdateworkrequest';
    },
    bulkObjectRequestForm() {
      return this.medicalApiUrl + '/api/metadata/bulkobjectedit';
    },
    bulkMdoAssigneeUpdateForm() {
      return this.medicalApiUrl + '/api/metadata/bulkMdoAssigneeeUpdate';
    },
    mdoWorkRequestForm() {
      return this.workflowApiUrl + '/api/metadata/bulkupdateworkrequest';
    },
    noteForm(): string {
      return `${this.noteApiUrl}/api/metadata/note`;
    },
    contactForm(): string {
      return `${this.entityApiUrl}/api/metadata/contact`;
    },
    deletedReasonForm() {
      return this.documentApiUrl + '/api/external/metadata/deletedocument/';
    },
    documentSearchForm() {
      return `${this.documentApiUrl}/api/metadata/documentsearch/`;
    },
    internalDocumentDetailsForm() {
      return `${this.documentApiUrl}/api/metadata/internaldocumentdetails/`;
    },
    internalDocumentUploadForm() {
      return `${this.documentApiUrl}/api/metadata/internaldocumentupload/`;
    },
    internalDocumentMoveForm() {
      return `${this.documentApiUrl}/api/metadata/internaldocumentmove/`;
    },
    externalwebformattachmentForm() {
      return `${this.documentApiUrl}/api/external/metadata/externalwebformattachment/`;
    },
    uploadedattachmentForm() {
      return `${this.filingApiUrl}/api/metadata/uploadedattachment/`;
    },
    externalDocumentDetailsForm() {
      return `${this.documentApiUrl}/api/external/metadata/externaldocumentdetails/`;
    },
    documentChangeForm(): string {
      return `${this.documentApiUrl}/api/metadata/change-form`;
    },
    formTemplateDetails() {
      return this.documentApiUrl + '/api/external/metadata/formtemplatedetails';
    },
    priorAuthorizationForm() {
      return this.medicalApiUrl + '/api/metadata/priorauthorization/';
    },
    medicalBillingDisputeForm() {
      return this.medicalApiUrl + '/api/metadata/medicalBillingDispute/';
    },
    medicalBillingDisputeWebForm() {
      return this.medicalApiUrl + '/api/metadata/medicalbillingdisputewebform';
    },
    // ------ start Prior Authorization Request forms ------
    priorAuthRequestForm() {
      return this.medicalApiUrl + '/api/metadata/priorAuthorizationRequest';
    },
    priorAuthRequestConsistentForm() {
      return this.medicalApiUrl + '/api/metadata/priorAuthorizationRequest/consistent';
    },
    priorAuthRequestMedicationForm() {
      return this.medicalApiUrl + '/api/metadata/priorAuthorizationRequest/medication';
    },
    priorAuthRequestDurableMedicalEquipmentForm() {
      return this.medicalApiUrl + '/api/metadata/priorAuthorizationRequest/durableMedicalEquipment';
    },
    priorAuthRequestNonMtgOver1000Form() {
      return this.medicalApiUrl + '/api/metadata/priorAuthorizationRequest/nonMtgOver1000';
    },
    priorAuthRequestNonMtgUnder1000Form() {
      return this.medicalApiUrl + '/api/metadata/priorAuthorizationRequest/nonMtgUnder1000';
    },
    priorAuthRequestSpecialServicesForm() {
      return this.medicalApiUrl + '/api/metadata/priorAuthorizationRequest/specialServices';
    },
    priorAuthRequestVarianceForm() {
      return this.medicalApiUrl + '/api/metadata/priorAuthorizationRequest/variance';
    },
    priorAuthRequestBaseLineItemForm() {
      return this.medicalApiUrl + '/api/metadata/priorAuthorizationRequest/lineItem';
    },
    priorAuthRequestBodyPartLineItemForm() {
      return this.medicalApiUrl + '/api/metadata/priorAuthorizationRequest/lineItem/bodyPart';
    },
    priorAuthRequestMtgRequestDetailsLineItemForm() {
      return (
        this.medicalApiUrl + '/api/metadata/priorAuthorizationRequest/lineItem/mtgRequestDetails'
      );
    },
    priorAuthRequestHcpcsLineItemForm() {
      return this.medicalApiUrl + '/api/metadata/priorAuthorizationRequest/lineItem/hcpcs';
    },
    priorAuthRequestMtgLineItemForm() {
      return this.medicalApiUrl + '/api/metadata/priorAuthorizationRequest/lineItem/mtg';
    },
    priorAuthRequestMdoReview() {
      return this.medicalApiUrl + '/api/metadata/priorAuthorizationRequest/mdoReview';
    },
    priorAuthRequestMdoReviewDetail() {
      return (
        this.medicalApiUrl + '/api/metadata/priorAuthorizationRequest/lineItem/mdoReviewDetail'
      );
    },
    medicalDirectorsOfficeReviewSearchForm() {
      return this.medicalApiUrl + '/api/metadata/medicalDirectorsOfficeReviewSearch';
    },
    priorAuthorizationRequestSearchForm() {
      return this.medicalApiUrl + '/api/metadata/priorAuthorizationRequestSearch';
    },
    priorAuthorizationRequestExternalSearchForm() {
      return this.medicalApiUrl + '/api/metadata/priorAuthorizationRequestExternalSearch';
    },
    priorAuthRequestClaimSearchForm() {
      return this.medicalApiUrl + '/api/metadata/priorAuthorizationRequest/claimSearch';
    },
    priorAuthRequestClaimDetailsIntakeForm() {
      return this.medicalApiUrl + '/api/metadata/priorAuthorizationRequest/claimDetailsIntake';
    },
    priorAuthorizationRelatedClaimant() {
      return this.medicalApiUrl + '/api/metadata/priorAuthorizationRelated/claimant';
    },
    priorAuthorizationRelatedHealthcareProvider() {
      return this.medicalApiUrl + '/api/metadata/priorAuthorizationRelated/healthcareProvider';
    },
    priorAuthorizationRelatedInsurer() {
      return this.medicalApiUrl + '/api/metadata/priorAuthorizationRelated/insurer';
    },
    priorAuthorizationRelatedSenderEntity() {
      return this.medicalApiUrl + '/api/metadata/priorAuthorizationRelated/senderEntity';
    },
    priorAuthorizationRelatedClaimAdminEntity() {
      return this.medicalApiUrl + '/api/metadata/priorAuthorizationRelated/claimAdminEntity';
    },
    priorAuthorizationRelatedUser() {
      return this.medicalApiUrl + '/api/metadata/priorAuthorizationRelated/user';
    },
    priorAuthorizationRelatedRemoveAllUsers() {
      return this.medicalApiUrl + '/api/metadata/priorAuthorizationRelated/removeAllUsers';
    },
    uploadExternalPriorAuthDocument() {
      return `${this.medicalApiUrl}/api/metadata/uploadExternalPriorAuthDocument/`;
    },
    updatePriorAuthSenderForm() {
      return `${this.medicalApiUrl}/api/metadata/updatePriorAuthSenderForm/`;
    },
    mdoReviewForm() {
      return this.medicalApiUrl + '/api/metadata/medicalDirectorsOfficeReview';
    },
    mdoReviewConfirmNoticeForm() {
      return this.medicalApiUrl + '/api/metadata/medicalDirectorsOfficeReviewConfirmNoticeForm';
    },
    mdoReviewDeterminationsModalForm() {
      return (
        this.medicalApiUrl + '/api/metadata/medicalDirectorsOfficeReviewDeterminationsModalForm'
      );
    },
    mdoReviewsSubsectionForm() {
      return this.medicalApiUrl + '/api/metadata/medicalDirectorsOfficeReviewsSubsection';
    },
    parResponseForm() {
      return this.medicalApiUrl + '/api/metadata/parResponse';
    },
    grantLineItemForm() {
      return this.medicalApiUrl + '/api/metadata/parResponse/grantLineItem';
    },
    grantInPartLineItemForm() {
      return this.medicalApiUrl + '/api/metadata/parResponse/grantInPartLineItem';
    },
    denyLineItemForm() {
      return this.medicalApiUrl + '/api/metadata/parResponse/denyLineItem';
    },
    // ------ end Prior Authorization Request forms ------
    medicationL2RequestForm() {
      return this.medicalApiUrl + '/api/metadata/level2Review/medication';
    },
    providerInformationResponseForm() {
      return this.medicalApiUrl + '/api/metadata/providerinformationresponse';
    },
    providerInformationRequestForm() {
      return this.medicalApiUrl + '/api/metadata/providerinformationrequest';
    },
    proofOfResponsibleEntityForm() {
      return this.medicalApiUrl + '/api/metadata/proofofresponsibleentity';
    },
    wizardWebForm() {
      return this.medicalApiUrl + '/api/metadata/wizardwebform';
    },
    internalUpdateStatusForm() {
      return this.workflowApiUrl + '/api/metadata/internalupdatestatus';
    },
    internalBulkUpdateStatusForm() {
      return this.workflowApiUrl + '/api/metadata/internalbulkupdatestatus';
    },
    reassignForm() {
      return this.workflowApiUrl + '/api/metadata/reassignobject';
    },
    objectStatusForm() {
      return this.refApiUrl + '/api/metadata/objectstatus';
    },
    standardWorkRequestForm() {
      return this.workflowApiUrl + '/api/metadata/standardworkrequest';
    },
    workRequestConfigForm() {
      return this.workflowApiUrl + '/api/metadata/workrequestconfiguration';
    },
    systemUserAdminForm() {
      return this.userApiUrl + '/api/metadata/systemuseradmin';
    },
    systemAccessGroupAdminForm() {
      return this.userApiUrl + '/api/metadata/systemAccessGroupAdminForm';
    },
    workGroupAdminForm() {
      return this.userApiUrl + '/api/metadata/workgroupadmin';
    },
    referenceDataForm() {
      return this.refApiUrl + '/api/metadata/referenceData';
    },
    referenceDataAdminForm() {
      return this.refApiUrl + '/api/metadata/referenceDataAdministration';
    },
    priorAuthWorkRequestAssigneeForm() {
      return this.medicalApiUrl + '/api/metadata/assignees';
    },
    _initialize(config: Environment) {
      this.entityApiUrl = config.baseUrls.entityApiUrl;
      this.userApiUrl = config.baseUrls.userApiUrl;
      this.documentApiUrl = config.baseUrls.documentApiUrl;
      this.medicalApiUrl = config.baseUrls.medicalApiUrl;
      this.noteApiUrl = config.baseUrls.noteApiUrl;
      this.workflowApiUrl = config.baseUrls.workflowApiUrl;
      this.refApiUrl = config.baseUrls.refApiUrl;
      this.filingApiUrl = config.baseUrls.filingApiUrl;
    },
  };

  notification = {
    notificationHub() {
      return `${this.notificationApiUrl}/notification`;
    },
    _initialize(config: Environment) {
      this.notificationApiUrl = config.baseUrls.notificationApiUrl;
    },
  };

  postalCodePrepopulate = {
    get(postalCode: string) {
      return `${this.postalCodePrepopulateUrl}/${postalCode}`;
    },
    _initialize(config: Environment) {
      this.postalCodePrepopulateUrl = config.baseUrls.refApiUrl + '/api/postalCodePrepopulate';
    },
  };

  priorAuthorization = {
    get(id: number) {
      return `${this.priorAuthorizationApiUrl}/api/priorauthorization/${id}`;
    },
    getRelatedRequests(claimId: number) {
      return `${this.priorAuthorizationApiUrl}/api/priorauthorization/relatedPriorAuthRequests/${claimId}`;
    },
    getMdoReviewType(id: number) {
      return `${this.priorAuthorizationApiUrl}/api/external/priorauthorization/mdoReviewType/${id}`;
    },
    priorAuth() {
      return `${this.priorAuthorizationApiUrl}/api/priorauthorization/priorAuth`;
    },
    durableMedicalEquipmentLineItems(priorAuthId: number) {
      return `${this.priorAuthorizationApiUrl}/api/priorauthorization/${priorAuthId}/line-items/durable-medical-equipment`;
    },
    medicationLineItem(priorAuthId: number) {
      return `${this.priorAuthorizationApiUrl}/api/priorauthorization/${priorAuthId}/line-items/medication`;
    },
    mtgLineItems(priorAuthId: number) {
      return `${this.priorAuthorizationApiUrl}/api/priorauthorization/${priorAuthId}/line-items/mtg`;
    },
    nonMtgLineItems(priorAuthId: number) {
      return `${this.priorAuthorizationApiUrl}/api/priorauthorization/${priorAuthId}/line-items/non-mtg`;
    },
    specialServiceLineItems(priorAuthId: number) {
      return `${this.priorAuthorizationApiUrl}/api/priorauthorization/${priorAuthId}/line-items/special-service`;
    },
    correspondenceHistory(id: number) {
      return `${this.priorAuthorizationApiUrl}/api/priorauthorization/${id}/correspondence-history`;
    },
    varianceDraftFromMtgSelections() {
      return `${this.priorAuthorizationApiUrl}/api/priorauthorizationrequest/variance/draft/frommtgselections`;
    },
    getRelatedClaimant(id: number) {
      return `${this.priorAuthorizationApiUrl}/api/priorauthorization/relatedClaimant/${id}`;
    },
    getRelatedHealthcareProvider(id: number) {
      return `${this.priorAuthorizationApiUrl}/api/priorauthorization/relatedHealthcareProvider/${id}`;
    },
    getRelatedInsurer(id: number) {
      return `${this.priorAuthorizationApiUrl}/api/priorauthorization/relatedInsurer/${id}`;
    },
    getRelatedSenderEntity(id: number) {
      return `${this.priorAuthorizationApiUrl}/api/priorauthorization/relatedSenderEntity/${id}`;
    },
    getRelatedSenderUsers(id: number) {
      return `${this.priorAuthorizationApiUrl}/api/priorauthorization/relatedSenderUsers/${id}`;
    },
    addRelatedEntityUser(id: number) {
      return `${this.priorAuthorizationApiUrl}/api/priorauthorization/relatedEntityUser/${id}`;
    },
    updateRelatedEntityUser() {
      return `${this.priorAuthorizationApiUrl}/api/priorauthorization/relatedEntityUser`;
    },
    removeAccessForAllRelatedUsers() {
      return `${this.priorAuthorizationApiUrl}/api/priorauthorization/removeAccessForAllRelatedUsers`;
    },
    submitProviderInformationResponse() {
      return `${this.priorAuthorizationApiUrl}/api/priorauthorization/providerInformationResponse`;
    },
    getRelatedUsersForNotification(id: number) {
      return `${this.priorAuthorizationApiUrl}/api/priorauthorization/relatedEntityusersForNotification/${id}`;
    },
    notifyUsersDocumentUpload() {
      return `${this.priorAuthorizationApiUrl}/api/priorauthorization/notifyUsersDocumentUpload`;
    },
    uploadExternalPriorAuthDocument(id: number) {
      return `${this.priorAuthorizationApiUrl}/api/priorauthorization/uploadExternalPriorAuthDocument/${id}`;
    },
    saveL2Draft() {
      return `${this.priorAuthorizationApiUrl}/api/level2Request/draft`;
    },
    getL2Request(filingId: number) {
      return `${this.priorAuthorizationApiUrl}/api/level2Request/draft/${filingId}`;
    },
    readyToSubmitL2Review() {
      return `${this.priorAuthorizationApiUrl}/api/level2Request/readyToSubmit`;
    },
    submitL2Review() {
      return `${this.priorAuthorizationApiUrl}/api/level2Request/submit`;
    },
    _initialize(config: Environment) {
      this.priorAuthorizationApiUrl = config.baseUrls.medicalApiUrl;
    },
  };
  priorAuthorizationWorkRequest = {
    bulkUpdate() {
      return `${this.medicalApiUrl}/api/priorauthorization/bulkedit`;
    },
    _initialize(config: Environment) {
      this.medicalApiUrl = config.baseUrls.medicalApiUrl;
    },
  };
  mdoReviewRequest = {
    request() {
      return this.mdoReviewRequestApiUrl;
    },
    _initialize(config: Environment) {
      this.mdoReviewRequestApiUrl = `${config.baseUrls.medicalApiUrl}/api/mdoReviewRequest`;
    },
  };

  imeRequest = {
    canRequestIme(id: number) {
      return `${this.imeRequestUrl}/${id}`;
    },
    submitImeRequest() {
      return `${this.imeRequestUrl}`;
    },
    _initialize(config: Environment) {
      this.imeRequestUrl = config.baseUrls.medicalApiUrl + '/api/imerequest';
    },
  };

  medicalBillingDispute = {
    get(id: number) {
      return `${this.medicalBillingDisputeUrl}/api/medicalBillingDispute/${id}`;
    },
    _initialize(config: Environment) {
      this.medicalBillingDisputeUrl = config.baseUrls.medicalApiUrl;
    },
  };

  medicalBilling = {
    preview() {
      return `${this.medicalBillingApiUrl}/api/medicalbilling/HP1/Preview`;
    },
    readyToSubmit() {
      return `${this.medicalBillingApiUrl}/api/medicalbilling/HP1/ReadyToSubmit`;
    },
    submit() {
      return `${this.medicalBillingApiUrl}/api/medicalbilling/HP1`;
    },
    _initialize(config: Environment) {
      this.medicalBillingApiUrl = config.baseUrls.medicalApiUrl;
    },
  };

  newPriorAuthApiUrl: string;
  priorAuthReferenceApiUrl: string;
  priorAuthRequestApiUrl: string;

  priorAuthorizationRequest = {
    search: () => `${this.priorAuthRequestApiUrl}/search`,
    confirmation: {
      preview: () => `${this.newPriorAuthApiUrl}/consistent/preview`,
      readyToSubmit: () => `${this.newPriorAuthApiUrl}/consistent/readyToSubmit`,
      submit: () => `${this.newPriorAuthApiUrl}/consistent`,
    },
    medication: {
      preview: () => `${this.newPriorAuthApiUrl}/medication/preview`,
      readyToSubmit: () => `${this.newPriorAuthApiUrl}/medication/readyToSubmit`,
      submit: () => `${this.newPriorAuthApiUrl}/medication`,
    },
    durableMedicalEquipment: {
      preview: () => `${this.newPriorAuthApiUrl}/durableMedicalEquipment/preview`,
      readyToSubmit: () => `${this.newPriorAuthApiUrl}/durableMedicalEquipment/readyToSubmit`,
      submit: () => `${this.newPriorAuthApiUrl}/durableMedicalEquipment`,
    },
    nonMtgOver1000: {
      preview: () => `${this.newPriorAuthApiUrl}/nonMtgOver1000/preview`,
      readyToSubmit: () => `${this.newPriorAuthApiUrl}/nonMtgOver1000/readyToSubmit`,
      submit: () => `${this.newPriorAuthApiUrl}/nonMtgOver1000`,
    },
    nonMtgUnder1000: {
      preview: () => `${this.newPriorAuthApiUrl}/nonMtgUnder1000/preview`,
      readyToSubmit: () => `${this.newPriorAuthApiUrl}/nonMtgUnder1000/readyToSubmit`,
      submit: () => `${this.newPriorAuthApiUrl}/nonMtgUnder1000`,
    },
    specialServices: {
      preview: () => `${this.newPriorAuthApiUrl}/specialServices/preview`,
      readyToSubmit: () => `${this.newPriorAuthApiUrl}/specialServices/readyToSubmit`,
      submit: () => `${this.newPriorAuthApiUrl}/specialServices`,
    },
    variance: {
      preview: () => `${this.newPriorAuthApiUrl}/variance/preview`,
      readyToSubmit: () => `${this.newPriorAuthApiUrl}/variance/readyToSubmit`,
      submit: () => `${this.newPriorAuthApiUrl}/variance`,
    },
    support: {
      checkForExistingMtgPar: () => `${this.newPriorAuthApiUrl}/existing-mtg-par`,
      checkForExistingSpecialServicePar: () =>
        `${this.newPriorAuthApiUrl}/existing-special-services-par`,
    },
    reference: {
      getMtgSites: () => `${this.priorAuthReferenceApiUrl}/mtg-sites`,
      getMtgsByMtgSite: (mtgSiteId: number) =>
        `${this.priorAuthReferenceApiUrl}/mtg-site/${mtgSiteId}/mtgs`,
      getBodyPartsByMtgSite: (mtgSiteId: number) =>
        `${this.priorAuthReferenceApiUrl}/mtg-site/${mtgSiteId}/body-parts`,
      getSidesOfBodyByBodyPart: (bodyPartId: number) =>
        `${this.priorAuthReferenceApiUrl}/body-part/${bodyPartId}/sides-of-body`,
      getMedicalFeeScheduleRegion: (zipCode: string) =>
        `${this.priorAuthReferenceApiUrl}/medical-fee-schedule-region-by-zip-code/${zipCode}`,
      getConversionFactor: () => `${this.priorAuthReferenceApiUrl}/conversion-factor`,
      checkHcpCanCreatePar: () => `${this.priorAuthReferenceApiUrl}/hcp-can-create-par`,
      getPriorAuthResponseReasons: () => `${this.priorAuthReferenceApiUrl}/response-reasons`,
      checkCptMtgSiteMapping: () => `${this.priorAuthReferenceApiUrl}/checkCptMtgSiteMapping`,
      GetMtgSiteByCptCode:(cptCodeId:number) => `${this.priorAuthReferenceApiUrl}/cpt/${cptCodeId}/mtgs`,
    },
    _initialize: (config: Environment) => {
      this.newPriorAuthApiUrl =
        config.baseUrls.medicalApiUrl + '/api/external/priorAuthorizationRequest';
      this.priorAuthReferenceApiUrl = config.baseUrls.refApiUrl + '/api/priorAuthRequest';
      this.priorAuthRequestApiUrl =
        config.baseUrls.medicalApiUrl + '/api/external/priorAuthorizationRequest';
    },
  };
  medicalDirectorsOfficeReview = {
    get(id: number) {
      return `${this.mdoReviewUrl}/${id}`;
    },
    update(id: number) {
      return `${this.mdoReviewUrl}/${id}`;
    },
    search() {
      return `${this.mdoReviewUrl}/search`;
    },
    getAssociatedMdoReviewForPriorAuth(id: number) {
      return `${this.mdoReviewUrl}/${id}/associatedMdoReview`;
    },
    getConfirmationDeterminations(id: number) {
      return `${this.mdoReviewUrl}/confirmationDeterminations/${id}`;
    },
    getDmeDeterminations(id: number) {
      return `${this.mdoReviewUrl}/dmeDeterminations/${id}`;
    },
    getMedicationDeterminations(id: number) {
      return `${this.mdoReviewUrl}/medicationDeterminations/${id}`;
    },
    getSpecialServicesDeterminations(id: number) {
      return `${this.mdoReviewUrl}/specialServicesConfirmations/${id}`;
    },
    getVarianceDeterminations(id: number) {
      return `${this.mdoReviewUrl}/varianceDeterminations/${id}`;
    },
    saveDetermination() {
      return `${this.mdoReviewUrl}/determination`;
    },
    preview() {
      return `${this.mdoReviewUrl}/DecisionLetter/Preview`;
    },
    notifyParties() {
      return `${this.mdoReviewUrl}/DecisionLetter/Resolution`;
    },
    queue() {
      return `${this.mdoReviewUrl}/queue`;
    },
    _initialize(config: Environment) {
      this.mdoReviewUrl = config.baseUrls.medicalApiUrl + '/api/medicalDirectorsOfficeReview';
    },
  };

  claim = {
    get(id: number) {
      return `${this.claimUrl}/${id}`;
    },
    search() {
      return `${this.claimUrl}/search/`;
    },
    _initialize(config: Environment) {
      this.claimUrl = config.baseUrls.claimApiUrl + '/api/claim';
    },
  };

  objectStatus = {
    getByObjectTypeCode() {
      return `${this.objectStatusUrl}/type`;
    },
    getListByObjectTypeCode(typeCode: string) {
      return `${this.objectStatusUrl}/type/${typeCode}/list`;
    },
    getListByObjectSubType(subTypeId: number) {
      return `${this.objectStatusUrl}/subtype/${subTypeId}/list`;
    },
    getMdoReviewObjectStatusOptions(currentObjectStatusId: number) {
      return `${this.objectStatusUrl}/${currentObjectStatusId}/list`;
    },
    get(id: number) {
      return `${this.objectStatusUrl}/${id}`;
    },
    save() {
      return `${this.objectStatusUrl}/`;
    },
    moveUp(id: number) {
      return `${this.objectStatusUrl}/${id}/moveup`;
    },
    moveDown(id: number) {
      return `${this.objectStatusUrl}/${id}/movedown`;
    },
    default(id: number) {
      return `${this.objectStatusUrl}/${id}/default`;
    },
    deactivate(id: number) {
      return `${this.objectStatusUrl}/${id}/deactivate`;
    },
    activate(id: number) {
      return `${this.objectStatusUrl}/${id}/activate`;
    },
    _initialize(config: Environment) {
      this.objectStatusUrl = config.baseUrls.refApiUrl + '/api/objectStatus';
    },
  };

  urlsForSystemType(typeCode: SystemTypeCode) {
    switch (typeCode) {
      case ObjectTypeCode.MdoReviewRequest:
        return this.medicalDirectorsOfficeReview;
      case ObjectTypeCode.PriorAuthorization:
        return this.priorAuthorization;
      case ObjectTypeCode.MedicalBillingDispute:
        return this.medicalBillingDispute;
      default:
        throw new Error(`No URLs found for type code ${typeCode}.`);
    }
  }
}
